<template>
  <div class="courseDetail">
    <!-- <Header msg=''/> -->
    <div class="course-msg">
      <p>{{this.pageData.videoText || '-'}}</p>
      <!-- <span>{{videoMSG.name || '-'}}(共{{count}}课时)</span> -->
    </div>
    <div class="course-video">
      <!-- <img src="@/assets/mine/course_bg01@3x.png"  /> -->
      <video controls class="video" :src="videoMSG.url" controlsList="nodownload" preload="auto"></video>
    </div>
    <div class="course-msgs">
      <!-- <p>{{this.pageData.videoText || '-'}}</p> -->
      <span>{{videoMSG.name || '-'}}(共{{count}}课时)</span>
    </div>
    
    <div class="video-box flex flex-j-c-sa">
      <div class="videolist" v-for="(e, i) in videoArr" :key="`${i}pl`" @click="showVideo(e)">
        <img src="https://s3-qcloud.meiqia.com/pics.meiqia.bucket/avatars/20190718/eeaaf23e53fcddcd18f46342d58f5d39.jpg" alt="">
        <p class="ellipsis">{{e.name}}</p>
        <div class="listmask" v-show="e.judge">正在播放 ▶</div>
      </div>
      <div class="videolist" style="height:0px" v-for="(e, i) in 2" :key="`${i}ot`"></div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import courseSourece from '@/js/source.json';

export default {
  name: 'CourseDetail',
  components: {
    Header
  },
  data() {
    return {
      pageData: {}, // 页面数据
      videoMSG: {}, // 视频信息
      videoArr: [], // 视频列表
      count: 0 // 统计
    }
  },
  created() {
    this.pageData = JSON.parse(sessionStorage.getItem('_userType'));
    // this.pageData = {videoType:'HMath', videoText:'数学'}
    this.count = courseSourece[this.pageData.videoType].length;
    this.videoMSG = courseSourece[this.pageData.videoType][0];
    this.videoArr = courseSourece[this.pageData.videoType];
    this.videoArr[0].judge = true;
    // console.log(courseSourece[this.pageData.videoType]);
    // https://s3-qcloud.meiqia.com/pics.meiqia.bucket/avatars/20190718/eeaaf23e53fcddcd18f46342d58f5d39.jpg
  },
  mounted () {
  },
  methods: {
    // 视频播放
    showVideo(e) {
      if (e.id !== this.videoMSG.id) {
        e.judge = true;
        let obj = this.videoMSG;
        obj.judge = false;
        this.videoArr.splice((obj.id-1),1, obj);
        this.videoMSG = e;
        this.videoArr.splice((e.id-1),1, e);
      }
    }
  },
  watch: {
  }
};
</script>

<style lang="less" scoped>
  .courseDetail{
    min-height: 100vh;
    font-size: 0.15rem;
    .mint-header{
        background: transparent;
        z-index: 99999;
    }
    /deep/ .mint-button-icon{
      color: white;
    }
    .course-video{
      background: #eee;
      width: 100%;
      height: 2.11rem;
      position: fixed;
      top:0.55rem;
      left: 0;
      z-index: 9999;
      .video{
        width: 100%;
        height: 100%;
      }
      img{
        width: 100%;
        height: 100%;
      }
    }
    .course-msg, .course-msgs{
      // margin-top: 2.11rem;
      padding: 0.16rem;
      font-size: 0.16rem;
      color: black;
      text-align: left;
      flex-direction: column;
      background: white;
      height: 0.55rem;
      width: 100%;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9999;
      p{
        font-weight: bold;
      }
      span{
        color: #333333;
        font-size: 0.12rem;
        margin-top: 0.13rem;
      }
    }
    .course-msgs{
      top: 2.66rem;
    }
    .video-box{
      flex-wrap: wrap;
      margin-top: 3.25rem;
      padding-bottom: 0.2rem;
    }
    .videolist{
      width: 1.8rem;
      height: 1.8rem;
      margin-bottom: 0.05rem;
      position: relative;
      img{
        width: 100%;
      }
      p{
        position: absolute;
        bottom: 0;
        padding: 0.05rem;
        color: white;
        width: 100%;
      }
      .listmask{
        width: 100%;
        height: 100%;
        color: white;
        line-height: 1.8rem;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0,0,0,.5);
        font-size: 0.16rem;
      }
    }
  }
</style> 

